export function StepNav({
  onBack,
  onNext,
  nextEnabled,
  nextLabel,
}: {
  onBack?: () => void;
  onNext: () => void;
  nextEnabled: boolean;
  nextLabel: string;
}) {
  return (
    <div className="mt-10 flex items-center justify-between border-t border-border pt-6">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="cursor-pointer text-sm text-link underline underline-offset-2 hover:text-ink"
        >
          ← Tilbage
        </button>
      ) : (
        <span />
      )}
      <button
        type="button"
        onClick={onNext}
        disabled={!nextEnabled}
        className="cursor-pointer rounded bg-theme px-7 py-3.5 text-[15px] font-medium text-white transition hover:bg-theme-dark disabled:pointer-events-none disabled:opacity-50"
      >
        {nextLabel}
      </button>
    </div>
  );
}
